import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './style.css';
import Grid from '@material-ui/core/Grid';
import { Collapse } from 'react-collapse';
import { AiOutlineSearch } from 'react-icons/ai';
import SideNav from './../../../components/SideNav_PS';

export default function Tela_PS() {
    let [search, setSearch] = useState(false);
    return (
        <>
        <SideNav />
        <body id="Tela-PS">
        <div id="top-PS">
        <Grid container spacing={0} direction="row" justify="left"  alignItems="center" style={{ marginTop: '-35vh'}}>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"></Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>   
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"> 
                <Collapse isOpened={search}>
                    <input id="Tela_PS" type="text" placeholder="pesquisa..." />
                </Collapse>
                <AiOutlineSearch
                    size={"6vh"}
                    onClick={() =>
                        setSearch(!search)
                    }
                    id="Icon-Search-PS"
                />
            </Grid>
        </Grid>
        </div>
        <Grid container spacing={0} direction="row" justify="center"  alignItems="center" style={{ minHeight: '20vh', maxWidth: '100%' }}> 
            <Grid item xs={12} sm={12} md={12} lg={12} align="center">
                <div id="title-PS">
                <h2 id="PS">Seja Bem-vindo(a)!</h2>
                </div>
            </Grid>
        </Grid>
        <Grid container spacing={0} direction="row" justify="center"  alignItems="center" style={{ maxWidth: '100%' }}> 
            <Grid item xs={12} sm={12} md={0} lg={1}></Grid>
            <Grid item xs={12} sm={12} md={4} lg={3} align="center">
                <NavLink id="PS" to="/login_m"><button id="PS">Login</button></NavLink>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={3} align="center">
                <NavLink id="PS" to="/tela_ps_cadastro"><button id="PS">Cadastre-se</button></NavLink>
            </Grid>
            <Grid item xs={12} sm={12} md={0} lg={1}></Grid>
        </Grid>
        </body>
        </>
    );
}